import {
  SNACKBAR_HIDE,
  SNACKBAR_SHOW,
} from '../mutation-types';


// state
const localState = {
  visible: false,
  text: null,
  timeout: 3000,
  multiline: false,
  color: 'info',
};

// mutations
const mutations = {
  [SNACKBAR_SHOW](state, payload) {
    state.text = payload.text;
    state.multiline = (payload.text.length > 50);

    if (payload.multiline) {
      state.multiline = payload.multiline;
    }

    if (payload.timeout) {
      state.timeout = payload.timeout;
    }

    if (payload.color) {
      state.color = payload.color;
    }

    state.visible = true;
  },
  [SNACKBAR_HIDE](state) {
    state.visible = false;
    state.multiline = false;
    state.timeout = 3000;
    state.text = null;
  },
};

// actions
const actions = {

};

export default {
  state: localState,
  mutations,
  actions,
};
